import instance from "../../../api";


export const RegisterService = {
  async Register(payload: Object) {
    return instance.post("users/", payload, { headers: { 'Content-Type': 'multipart/form-data' }}).then((response) => response.data);
  },
};
